/** Shopify CDN: Minification failed

Line 17:0 Transforming let to the configured target environment ("es5") is not supported yet
Line 18:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 18:18 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 21:1 Transforming const to the configured target environment ("es5") is not supported yet
Line 23:1 Transforming const to the configured target environment ("es5") is not supported yet
Line 24:1 Transforming let to the configured target environment ("es5") is not supported yet
Line 25:1 Transforming let to the configured target environment ("es5") is not supported yet
Line 26:1 Transforming let to the configured target environment ("es5") is not supported yet
Line 28:1 Transforming const to the configured target environment ("es5") is not supported yet
Line 31:1 Transforming const to the configured target environment ("es5") is not supported yet
... and 4 more hidden warnings

**/

let currentPaginationPage = 1
let canPass = true
const loadItems = async (button,needReturn) => {
	if(canPass || needReturn){
		canPass = false
		currentPaginationPage++
		localStorage.setItem('currentPage', currentPaginationPage);
		const page = localStorage.getItem('currentPage');
		//console.log('page: '+ page + '/' + currentPaginationPage)
		const totalPages = parseInt($("[data-total-pages]").val());
		let currentPageScroll = currentPaginationPage + 1;
		let toReturn
		const nextUrl = $("[data-next-url]")
			.val()
			.replace(/page=[0-9]+/, "page=" + currentPaginationPage);
		const nextUrlScroll = $("[data-next-url]")
			.val()
			.replace(/page=[0-9]+/, "page=" + currentPageScroll);
		$("[data-current-page]").val(currentPaginationPage);

		button.setAttribute("disabled", "");
		button.classList.add("loading");

		await $.ajax({
			url: nextUrl,
			type: "GET",
			dataType: "html",
			success: function (responseHTML) {
				if(!needReturn){
					$(".load-more-grid").append(
						$(responseHTML).find(".load-more-grid").html()
					);
					colorSwatches();
				}
				else{
					toReturn = $(responseHTML).find(".load-more-grid").html()
				}
			},
			complete: function () {
				canPass = true
				if (currentPaginationPage <= totalPages) {
					const scollData = document.querySelector(".infinite-scroll__data");
					if (scollData && currentPaginationPage != totalPages) {
						scollData.querySelector("input[data-next-url]").dataset.nextUrl =
							nextUrlScroll;
						scollData.querySelector("input[data-next-url]").value = nextUrlScroll;
						scollData.querySelector(
							"input[data-current-page]"
						).dataset.currentPaginationPage = currentPaginationPage;
						scollData.querySelector("input[data-current-page]").value =
							currentPaginationPage;
						checkVisibility();
					}
					button.removeAttribute("disabled");
					button.classList.remove("loading");
					if (currentPaginationPage == totalPages) {
						button.remove();
					}
				}
			},
		});
		return toReturn
	}
};

const checkVisibility = () => {
	const spinnerList = document.querySelectorAll(".js-infinite-scroll");
	spinnerList.forEach((spinner) => {
		const sectionObserver = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					loadItems(spinner);
				}
			});
		});

		sectionObserver.observe(spinner);
	});
};

function loadMore() {
	document.querySelectorAll(".js-load-more").forEach((button) => {
		button.onclick = () => {
			loadItems(button);
		};
	});

	checkVisibility();
}

(function () {
	loadMore();
	checkVisibility();
})();
